// Shared utility functions for ADM charts

// Helper to cumulate datapoints with intervals
// Preserves the date field for tooltip display
export const cumulateDatapoints = (datapoints) => {
  const cumulated = [];
  if (datapoints && datapoints.length > 0) {
    for (let i = 0; i < datapoints.length; i++) {
      cumulated.push({
        interval: datapoints[i].interval,
        value: datapoints[i].value,
        date: datapoints[i].date // Preserve date for tooltip
      });
      if (i > 0) {
        cumulated[i].value += cumulated[i - 1].value;
      }
    }
  }
  return cumulated;
};

// Add intermediate points before slope changes to create sharp transitions
export const addSharpTransitions = (datapoints) => {
  if (!datapoints || datapoints.length < 2) return datapoints;

  const result = [datapoints[0]];

  for (let i = 1; i < datapoints.length; i++) {
    const prev = datapoints[i - 1];
    const curr = datapoints[i];

    // Calculate slopes
    const intervalDiff = curr.interval - prev.interval;
    if (intervalDiff === 0) {
      result.push(curr);
      continue;
    }

    // Check if slope changed significantly (more than 0.01 difference)
    const slopeThreshold = 0.01;
    if (Math.abs(curr.value - prev.value) > slopeThreshold && i > 1) {
      result.push({
        interval: curr.interval,
        value: prev.value,
        date: curr.date
      });
    }

    result.push(curr);
  }

  return result;
};

// Helper to check if data exists
export const dataExists = (data) => {
  return data && data.reduce((acc, curr) => acc + curr.value, 0) !== 0;
};

// Calculate open defects by subtracting cumulative closure from cumulative arrival
export const calculateOpenDefects = (arrivalData, closureData) => {
  if (!arrivalData || !closureData || arrivalData.length === 0 || closureData.length === 0) {
    return [];
  }

  const cumulativeArrival = cumulateDatapoints(arrivalData);
  const cumulativeClosure = cumulateDatapoints(closureData);

  // Match by interval
  const openDefects = [];
  for (let i = 0; i < cumulativeArrival.length; i++) {
    const arrivalPoint = cumulativeArrival[i];
    const closurePoint = cumulativeClosure.find(c => c.interval === arrivalPoint.interval);

    if (closurePoint) {
      openDefects.push({
        interval: arrivalPoint.interval,
        value: Math.max(0, arrivalPoint.value - closurePoint.value), // Ensure non-negative
        date: arrivalPoint.date
      });
    } else {
      // If no closure data for this interval, all arrivals are open
      openDefects.push({
        interval: arrivalPoint.interval,
        value: arrivalPoint.value,
        date: arrivalPoint.date
      });
    }
  }

  return openDefects;
};

// Create line config for chart
export const createLineConfig = (id, data, color, strokeStyle = 'solid', legend = true) => ({
  id,
  data,
  color,
  strokeStyle,
  legend
});
